const list = [
    {
        id:1,
        title: "Peaky Blinders",
        Journer: "Action/Drama",
        Language: "English",
        Price: 400,
        img: "https://m.media-amazon.com/images/M/MV5BZjYzZDgzMmYtYjY5Zi00YTk1LThhMDYtNjFlNzM4MTZhYzgyXkEyXkFqcGdeQXVyMTE5NDQ1MzQ3._V1_.jpg",
        amount: 1,
    },
    {
        id:2,
        title: "Stranger Things",
        Journer: "Fantasy",
        Language: "English",
        Price: 200,
        img: "https://occ-0-987-33.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABV5lteI3eHet1nPBQKC_uEChESjqQfYpRwMWLR0wULt52odnxQtG69JNFDj9N4maZWJWDFZyi2sc1YzZ8mKE4Ajmt7Btva1CnWagGbYXVMp3t4OETM4LwiD70dHu-qWUbBAesQ.jpg?r=c68",
        amount: 1,
    },
    {
        id:3,
        title: "13 Reason Why",
        Journer: "Love",
        Language: "English",
        Price: 400,
        img: "https://upload.wikimedia.org/wikipedia/en/thumb/0/09/13_Reasons_Why_season_1_Soundtrack.jpg/220px-13_Reasons_Why_season_1_Soundtrack.jpg",
        amount: 1,
    },
    {
        id:4,
        title: "Breaking Bad",
        Journer: "Action",
        Language: "English",
        Price: 400,
        img: "https://rukminim1.flixcart.com/image/312/312/kmp7ngw0/poster/s/b/b/medium-breaking-bad-is-american-maxi-origins-jumbo-medium-size-original-imagfjguzg3bsyef.jpeg?q=70",
        amount: 1,
    },
     {
        id:5,
        title: "Game of Thrones",
        Journer: "Fantasy",
        Language: "English",
        Price: 500,
        img: "https://th.bing.com/th/id/OIP.wns50T36hTJjLTqeQ8bu0wHaKF?pid=ImgDet&rs=1",
        amount: 1,
    },
     {
        id:6,
        title: "Vikings",
        Journer: "Fantasy",
        Language: "English",
        Price: 500,
        img: "https://static.tvtropes.org/pmwiki/pub/images/vikings_6.jpg",
        amount: 1,
    },
     {
        id:7,
        title: "Friends",
        Journer: "Sitcom",
        Language: "English",
        Price: 300,
        img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS1x4uXDiokE5soyJXrPV8T2BcLRqCq7c-rNAm5Iix9pvRsdHW16cldEbu76GJRslf6pKU&usqp=CAU",
        amount: 1,
    },
     {
        id:8,
        title: "Office",
        Journer: "Sitcom",
        Language: "English",
        Price: 100,
        img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTj7u31oth09CehIcHoLVfFIdBkdD7xAoBAaw&usqp=CAU",
        amount: 1,
    },
     {
        id:9,
        title: "How I Met your Mother",
        Journer: "Sitcom",
        Language: "English",
        Price: 200,
        img: "https://picfiles.alphacoders.com/400/thumb-1920-400793.jpg",
        amount: 1,
    },
     {
        id:10,
        title: "Naruto",
        Journer: "Anime",
        Language: "English",
        Price: 300,
        img: "https://w0.peakpx.com/wallpaper/143/625/HD-wallpaper-itachi-uchiha-anime-naruto-saske.jpg",
        amount: 1,
    },
     {
        id:11,
        title: "Death Note",
        Journer: "Anime",
        Language: "English",
        Price: 400,
        img: "https://m.media-amazon.com/images/M/MV5BNjRiNmNjMmMtN2U2Yi00ODgxLTk3OTMtMmI1MTI1NjYyZTEzXkEyXkFqcGdeQXVyNjAwNDUxODI@._V1_FMjpg_UX1000_.jpg",
        amount: 1,
    },
     {
        id:12,
        title: "One Piece",
        Journer: "Anime",
        Language: "English",
        Price: 400,
        img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQuj63eqtdEez7uWMLpPzIIzmNa0vMSpWCA116wVuZ0TG4EdAKwE5tA-N4jJTggEUE3vtM&usqp=CAU",
        amount: 1,
    }
]

export default list;